import React, { useEffect } from 'react';
import {
  Typography,
  LinearProgress,
  CircularProgress,
} from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import { get, isEmpty, orderBy } from 'lodash';

import { Box, Button, Dialog } from 'components';
import { welcomeInvestorImg } from 'assets';
import history from 'common/utils/history';
import { RootState } from 'redux-modules/store/rootState';
import { Deal } from 'redux-modules/deals/Types';
import {
  convertAmountIntoReadableFormat,
  formatAmount,
} from 'common/utils/helpers';

import styles from './styles';

const InvestmentBulk = () => {
  const classes = styles();

  const { dealList, isLoading, errorMessage } = useSelector(
    ({ Deals }: RootState) => Deals,
  );
  const { investorDeals } = useSelector(({ Investor }: RootState) => Investor);

  const [modal, setModal] = React.useState<boolean>(false);
  const [newLatestDeal, setNewLatestDeal] = React.useState<any>([]);

  useEffect(() => {
    if (!isEmpty(dealList) && !isEmpty(investorDeals)) {
      const filteredDeal = dealList.filter((deal: any) => {
        return !investorDeals.includes(get(deal, 'id')) && !deal.closed;
      });
      const sortedDeal = orderBy(filteredDeal, ['order'], ['asc']);
      setNewLatestDeal(sortedDeal.slice(0, 2));
    } else {
      const filteredDeal = dealList.filter((deal: any) => !deal.closed);
      const sortedDeal = orderBy(filteredDeal, ['order'], ['asc']);
      setNewLatestDeal(sortedDeal.slice(0, 2));
    }
  }, [dealList, investorDeals]);

  // useEffect(() => {
  //   if (newLatestDeal.length > 0) {
  //     setModal(true);
  //   }
  // }, [newLatestDeal]);

  return (
    <Box className={classes.invstBulkContainer}>
      {errorMessage && (
        <Typography variant="body1" className={classes.errorMessage}>
          {errorMessage}
        </Typography>
      )}
      {isLoading ? (
        <Box className={classes.loader}>
          <CircularProgress color="inherit" size={40} />
        </Box>
      ) : (
        <Box>
          {/* {!isEmpty(newLatestDeal) && (
            <Box className={classes.notificationBox}>
              <Typography className={classes.notificationTxt}>
                <b>Attention</b> - We have added {newLatestDeal.length}{' '}
                <b>New Deals</b> -{' '}
                {newLatestDeal
                  .map((deal: any) => `${get(deal, 'fundTitle')} SPV`)
                  .join(',')}
              </Typography>
              <CloseIcon className={classes.closeIcon} />
            </Box>
          )} */}
          <Box className={classes.invstBulkContent}>
            {dealList.map((deal: Deal) => (
              <Box className={classes.invstBulkList} key={get(deal, 'id')}>
                <Typography className={classes.borderColor}></Typography>
                {newLatestDeal.some(
                  (nDeal: any) => get(nDeal, 'id') === get(deal, 'id'),
                ) && (
                  <Typography className={classes.newDeals}>New Deal</Typography>
                )}
                <Box className={classes.invstNameBox}>
                  <Box className={classes.invstNameLeft}>
                    <Typography className={classes.nameTxt}>
                      {get(deal, 'fundTitle')} SPV
                    </Typography>
                  </Box>
                  <Box className={classes.invstNameRight}>
                    <Typography className={classes.amountTxt}>
                      ${convertAmountIntoReadableFormat(get(deal, 'dealSize'))}
                    </Typography>
                    {!get(deal, 'closed') && (
                      <Typography className={classes.completeTxt}>
                        {get(deal, 'completedPercentage', 0)}% Funded
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box className={classes.invstBody}>
                  <LinearProgress
                    variant="determinate"
                    value={
                      !get(deal, 'closed')
                        ? parseInt(get(deal, 'completedPercentage') || 0)
                        : 100
                    }
                    className={classes.progressInvst}
                  />
                  <Typography className={classes.progressTxt}>
                    {get(deal, 'businessModel')}
                  </Typography>
                  <Typography className={classes.minInvstTxt}>
                    Min investment
                    <Typography
                      className={classes.minSubInvst}
                      variant="caption"
                    >
                      {formatAmount(get(deal, 'minimumInvestmentAmount'))}
                    </Typography>
                  </Typography>
                  <Button
                    name="Know more and Invest"
                    className={classes.knowBtn}
                    disabled={get(deal, 'closed')}
                    onClick={() =>
                      history.push(`deals?spv=${get(deal, 'deal')}`)
                    }
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      <Dialog
        open={modal}
        maxWidth={'sm'}
        title="Explore 8vdX"
        buttonText="Continue"
        handleClose={() => setModal(false)}
        className={classes.dialogStyles}
      >
        <Box>
          <Box className={classes.newDealBox}>
            <Typography variant="body1" className={classes.newDealsText}>
              New Deal
            </Typography>
          </Box>
          <Box className={classes.newDealBox}>
            <Typography variant="body1" className={classes.newDealsAdded}>
              8vdX added {newLatestDeal.length} New Deals -{' '}
              <b>
                {' '}
                {newLatestDeal
                  .map((deal: any) => `${get(deal, 'fundTitle')} SPV`)
                  .join(',')}
              </b>
            </Typography>
          </Box>
          <Box className={classes.welcomeBoxBody}>
            <img
              src={welcomeInvestorImg}
              alt={welcomeInvestorImg}
              className={classes.welcomeImgImage}
            />
          </Box>
          <Button
            className={classes.seeMoreBtnBox}
            name="See More"
            onClick={() => setModal(false)}
          />
        </Box>
      </Dialog>
    </Box>
  );
};
export default InvestmentBulk;
